import { ConvexReactClient } from "convex/react";

// URL-ul Convex din variabilele de mediu
const convexUrl = import.meta.env.VITE_CONVEX_URL;

if (!convexUrl) {
  throw new Error(
    "VITE_CONVEX_URL nu este definit. Rulează `npx convex dev` pentru a configura Convex."
  );
}

// Client Convex pentru React
export const convex = new ConvexReactClient(convexUrl);
